import { styled } from '@mui/material'
import MuiBadge from '@mui/material/Badge'
import { css } from '@emotion/react'
import { BadgeProps } from './Badge.types'

export const Badge = styled(MuiBadge)`
  ${(props: BadgeProps) =>
    props.required &&
    css`
      .MuiBadge-dot {
        top: 4px;
        right: 3px;
        min-width: 6px;
        height: 6px;
      }
      padding-right: 10px;
      line-height: 1;
      vertical-align: top;
    `};
`
